import * as React from 'react';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./offer-banner-details-additional-compensation-other.i18n.json'));

const MSG_KEY = 'offer_banner_details_additional_compensation_other';

const OfferBannerDetailsAdditionalCompensationOther: React.FC = () => {
  const text = __t(`${MSG_KEY}.labels.other_compensation`);

  return (
    <div
      className="offer-banner-details-additional-compensation-other"
      title={text}
    >
      {text}
    </div>
  );
};

export default OfferBannerDetailsAdditionalCompensationOther;
